
  export default {
    props: {
      hideFeefo: { type: Boolean, default: false }
    }
  };
